import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FlexModule } from '@angular/flex-layout';
import { NgIf } from '@angular/common';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';

export interface ConfirmDialogData {
  title: string;
  actionTitle: string;
  text: string;
  hideCancel: boolean;
  showCancelBtn: boolean;
}

@Component({
    selector: 'app-mat-confirm-dialog',
    templateUrl: './mat-confirm-dialog.component.html',
    standalone: true,
    imports: [
        MatDialogTitle,
        FlexModule,
        NgIf,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        MatDialogActions,
        MatButton,
    ],
})
export class MatConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData) {}
}
